import {
  div,
  h1,
  p
} from '@srfnstack/fntags'

export const Graveyard = () => div({ class: 'p-6' },
  h1({ class: 'text-3xl font-bold mb-6' }, 'Graveyard'),
  p({ class: 'opacity-60' }, 'No products have been decommissioned yet.')
)
